import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  analyticsContainer: {
    padding: theme.spacing(3),
    minHeight: 400,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}));

export default function PlantAnalytics({ plants, stats }) {
  const classes = useStyles();

  return (
    <Box className={classes.analyticsContainer}>
      <Typography color="textSecondary">
        Analytics and charts will be implemented here
      </Typography>
    </Box>
  );
}